import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'lt',
    fullName: 'Lithuanian',
    nativeName: 'Lietuvių',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Artėja kažkas nuostabaus",
    landing_subtitle: "ArgVoid yra programų ir žaidimų kūrimo studija. Sekite naujienas, netrukus pasirodys nauji dalykai!",
    select_language: "Pasirinkite Kalba",
    search_placeholder: "Ieškoti kalbų...",
    terms_title: "Paslaugų teikimo sąlygos",
    policy_title: "Privatumo politika",
    cookies_title: "Slapukų politika",
    terms_content: `
        <strong>1. Sąlygų priėmimas</strong><br>
        Prieiga prie ArgVoid sutinkama su šiomis paslaugų teikimo sąlygomis. Jei su šiomis sąlygomis nesutinkama, paslauga neturėtų būti naudojama.<br><br>

        <strong>2. Platformos naudojimas</strong><br>
        „ArgVoid“ ir jos programos pateikiamos „tokios, kokios yra“ informaciniais ir kūrybiniais tikslais. Paslauga turi būti naudojama tik teisėtais tikslais.<br>X<br>

        <strong>3. Draudžiamas elgesys</strong><br>
        Griežtai draudžiama išnaudoti svetainės pažeidžiamumą, siųsti šlamštą arba bandyti neteisėtai pasiekti infrastruktūrą.<br><br>

        <strong>4. Atsakomybės apribojimas</strong><br>
        Platforma ir paslaugos gali būti keičiamos bet kuriuo metu be įspėjimo. Garantija dėl paslaugos veikimo laiko ar prieinamumo nesuteikiama.
    `,
    policy_content: `
        <strong>1. Informacijos rinkinys</strong><br>
        Šiuo metu platforma nereikalauja vartotojo autentifikavimo ar paskyros kūrimo. Iš lankytojų aktyviai nerenkama jokia asmens identifikavimo informacija (pvz., vardai ar el. pašto adresai).<br><br>

        <strong>2. Naudojimo duomenys</strong><br>
        Norint suprasti svetainės srautą ir tobulinti programas, gali būti renkama pagrindinė, anoniminė analizė. Šie duomenys nėra susieti su individualiomis naudotojų tapatybėmis.<br>X<br>

        <strong>3. Trečiųjų šalių paslaugos</strong><br>
        Trečiųjų šalių teikėjai gali būti naudojami prieglobos ir analizės paslaugoms teikti. Šių atitinkamų teikėjų privatumo praktika reglamentuoja jų infrastruktūroje tvarkomus anoniminius duomenis.<br><br>

        <strong>4. Duomenų sauga</strong><br>
        Siekiant apsaugoti platformą, įgyvendinamos pagrįstos saugumo priemonės. Tačiau joks perdavimo internetu būdas nėra visiškai saugus.<br><br>
    `,
    cookies_content: `
        <strong>1. Kas yra slapukai ir vietinė saugykla?</strong><br>
        Slapukai ir naršyklės vietinė saugykla yra nedideli duomenų failai, saugomi įrenginyje, siekiant prisiminti konfigūracijos nuostatas apsilankymų metu.<br><br>

        <strong>2. Naudojimo tikslas</strong>X<br>
        Naršyklė „LocalStorage“ naudojama tik konfigūracijos nustatymams, pvz., <br>, išsaugoti
        – Kalbos nuostatos<br>
        - Vartotojo sąsajos konfigūracija (pvz., išdėstymo arba temos nustatymai) <br>
        - Laikinoji programos talpykla<br><br>

        <strong>3. Nėra Tracking</strong><br>
        Slapukai ir vietinė saugykla nenaudojami reklamos ar trečiųjų šalių stebėjimo tikslais. Visi saugomi duomenys yra skirti tik pagrindinėms platformos funkcijoms.<br><br>

        <strong>4. Control</strong><br>
        Naršyklės duomenis galima bet kada išvalyti naudojant naršyklės nustatymus, kurie iš naujo nustatys visas vietines konfigūracijas.
    `,
    cookie_consent_text: "Naudojame pagrindinius slapukus, kad užtikrintume tinkamą svetainės veikimą, pvz., kad seansas būtų aktyvus, išsaugotų kalbos nuostatas ir kitas pasirinktines konfigūracijas.",
    read_policy: "Perskaitykite slapukų politiką",
    support_title: "Susisiekite su palaikymo tarnyba",
    support_subject_label: "Tema",
    support_message_label: "Pranešimas",
    support_submit_button: "Siųsti žinutę",
    support_hint: "Pastaba: bus atidaryta numatytoji el. pašto programa, skirta žinutei siųsti.",
    support_success_msg: "Atidaroma el. pašto programa...",
    support_error_msg: "Nepavyko išsiųsti pranešimo. Bandykite dar kartą vėliau.",
    explorer_title: "Tyrinėtojas",
    history_title: "Istorija",
    animation_title: "Animacija",
    config_title: "Konfigūracija",
    tool_mouse: "Pasirinkite (Ctrl + M)",
    tool_brush: "Teptukas (Ctrl+B)",
    tool_brush_mode: "Perjungti režimą (vientisas / aiškus)",
    tool_eraser: "Trintukas (Ctrl + E)",
    tool_brush_size: "Sureguliuokite šepetėlio dydį",
    tool_bucket: "Užpildymas (Ctrl+F)",
    tool_eyedropper: "Akių lašintuvas",
    tool_grid: "Tinklelis (Ctrl + Shift + B)",
    tool_rotate: "Pasukti (Ctrl + Shift + R)",
    tool_flip_h: "Apversti H (Ctrl + Shift + H)",
    tool_flip_v: "Apversti V (Ctrl + Shift + V)",
    tool_transpose: "Transponuoti (Ctrl + Shift + T)",
    label_width: "Plotis",
    label_height: "Aukštis",
    label_frames: "Kadrų skaičius",
    label_animation: "Animacijos stilius",
    label_background_color: "Fono spalva",
    label_interval: "Intervalas",
    tool_anim_config: "Animacijos konfigūracija",
    label_new_width: "Naujas plotis",
    label_new_height: "Naujas aukštis",
    label_apply: "Taikyti",
    label_colors: "Spalvos",
    label_size: "Dydis",
    label_tolerance: "Tolerancija",
    val_horizontal: "Horizontalus",
    val_vertical: "Vertikalus",
    val_sequence: "Seka",
    val_bounce: "Atšokti",
    val_random: "Atsitiktinis",
    val_solid: "Tvirtas",
    val_clear: "Aišku",
    action_add_sheet: "Naujas lapas",
    action_import: "Importuoti",
    action_export: "Eksportuoti",
    action_sort_projects: "Rūšiuoti",
    sort_date_old: "Seniausi Pirma",
    sort_date_new: "Naujausi pirmiausia",
    sort_name_az: "Vardas (A–Z)",
    sort_name_za: "Vardas (Z-A)",
    action_new_sprite: "Naujas Sprite",
    action_new_project: "Naujas Projektas",
    modal_save_all_title: "Išsaugoti visus pakeitimus",
    modal_save_all_desc: "Pasirinkite išteklius, kuriuos norite išsaugoti:",
    modal_save_selected: "Išsaugoti pasirinktus",
    action_saved: "Išsaugota",
    modal_create_sprite_title: "Sukurkite naują „Sprite“.",
    modal_create_project_title: "Sukurti naują projektą",
    modal_add_sheet_title: "Pridėti naują lapą",
    modal_rename_sheet_title: "Pervardyti lapą",
    modal_rename_sprite_title: "Pervardykite „Sprite“.",
    modal_delete_sprite_title: "Ištrinti Sprite",
    modal_delete_project_title: "Ištrinti projektą",
    modal_delete_sheet_title: "Ištrinti lapą",
    placeholder_sprite_name: "Vardas",
    placeholder_project_name: "Vardas",
    placeholder_sheet_name: "Vardas",
    placeholder_new_name: "Naujas Vardas",
    action_create: "Sukurti",
    action_add: "Pridėti",
    action_rename: "Pervardyti",
    action_duplicate: "Pasikartoti",
    action_delete: "Ištrinti",
    action_cancel: "Atšaukti",
    confirm_delete_sprite: "Ar tikrai norite ištrinti šį sprite?",
    confirm_delete_project: "Ar tikrai norite ištrinti šį projektą? Visi spraitai bus pašalinti.",
    confirm_delete_sheet: "Ar tikrai norite ištrinti šį lapą?",
    err_select_sprite: "Pirmiausia pasirinkite sprite.",
    err_select_project: "Pirmiausia pasirinkite projektą.",
    err_name_empty: "Vardo laukas negali būti tuščias.",
    err_sprite_exists: "Sprite tokiu pavadinimu jau yra.",
    err_project_exists: "Projektas tokiu pavadinimu jau yra.",
    err_no_content: "Nėra turinio, kurį būtų galima išsaugoti.",
    err_no_changes: "Nereikia išsaugoti pakeitimų.",
    err_delete_last_sheet: "Negalima ištrinti paskutinio lapo.",
    err_extract_frames: "Nepavyko išskleisti jokių kadrų.",
    err_indexeddb: "Nepavyko išsaugoti vietoje. Jūsų naršyklė gali nepalaikyti IndexedDB.",
    msg_upload_success: "Įkėlimas sėkmingai: {0}",
    msg_upload_failed: "Įkelti nepavyko: {0}",
    msg_save_success: "Išsaugoti sėkmingai.",
    msg_saving: "Išsaugoma...",
    msg_multi_save_result: "Išsaugota {0} išteklių. {1} gedimų.",
    menu_title: "Meniu",
    menu_save: "Išsaugoti",
    menu_save_all: "Išsaugoti viską",
    menu_support: "Susisiekite su palaikymo tarnyba",
    label_local_storage: "Vietinė saugykla",
    label_sign_in: "Prisijunkite",
    modal_export_title: "Eksportuoti Sprite",
    label_filename: "Failo pavadinimas",
    label_format: "Formatas",
    action_export_confirm: "Eksportuoti",
};

export default translations;
